import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconOpenDoors: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="open-doors">
    <path
      fillRule="evenodd"
      d="M6.4 8.095V7A4.6 4.6 0 0 1 11 2.4h2A4.6 4.6 0 0 1 17.6 7v1.095c.54.093 1.057.201 1.546.323l.582.146-.291 1.164-.582-.146c-.3-.074-.61-.143-.93-.206l2.898 4.83-1.029.618-3.057-5.095-1.982 2.312c.156.285.245.612.245.96v2.5c0 .475-.166.911-.443 1.254l.942 1.413-.998.665-.942-1.412c-.177.052-.365.08-.559.08h-2c-.267 0-.522-.053-.755-.148l-.708 1.416-1.074-.537.838-1.676A1.99 1.99 0 0 1 9 15.5V13c0-.347.089-.674.245-.959L7.263 9.73l-3.057 5.095-1.03-.618 2.9-4.83c-.321.063-.632.132-.93.206l-.582.146-.292-1.164.583-.146c.488-.122 1.006-.23 1.545-.323ZM7.6 7A3.4 3.4 0 0 1 11 3.6h2A3.4 3.4 0 0 1 16.4 7v.917a36.494 36.494 0 0 0-8.8 0V7Zm6.289 4.208 1.852-2.161a35.695 35.695 0 0 0-7.482 0l1.852 2.161c.268-.133.57-.208.889-.208h2c.32 0 .621.075.889.208ZM13.8 15.5V13a.8.8 0 0 0-.8-.8h-2a.8.8 0 0 0-.8.8v2.5a.8.8 0 0 0 .8.8h2a.8.8 0 0 0 .8-.8Z"
    />
    <path d="M7.6 18v-2.1H6.4V18a3.6 3.6 0 0 0 3.6 3.6h4a3.6 3.6 0 0 0 3.6-3.6v-2.1h-1.2V18a2.4 2.4 0 0 1-2.4 2.4h-4A2.4 2.4 0 0 1 7.6 18Z" />
  </Icon>
);
